function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Label from './Label';
import './RadioButtonGroup.css';

var RadioButtonGroup = function (_Component) {
  _inherits(RadioButtonGroup, _Component);

  function RadioButtonGroup(props) {
    _classCallCheck(this, RadioButtonGroup);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleChange = function (e) {
      if (_this.isReadOnly()) {
        e.preventDefault();
        return;
      }

      _this.setState({
        value: e.target.value
      });

      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(e.target.value);
      }
    };

    _this.state = {
      value: props.value
    };
    _this.identifier = Math.floor(Math.random() * 100000);
    return _this;
  }

  RadioButtonGroup.prototype.componentDidMount = function componentDidMount() {};

  RadioButtonGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value
    });
  };

  RadioButtonGroup.prototype.getRadioName = function getRadioName() {
    return this.props.label + '-' + this.identifier;
  };

  RadioButtonGroup.prototype.parseOption = function parseOption(opt) {
    if (Array.isArray(opt)) {
      // format: [value, displayValue]
      return {
        value: opt[0],
        displayValue: opt[1]
      };
    }

    return {
      value: opt,
      displayValue: opt
    };
  };

  RadioButtonGroup.prototype.isActive = function isActive(option) {
    return option.value === this.state.value;
  };

  RadioButtonGroup.prototype.isDisabled = function isDisabled(option) {
    return this.isReadOnly() && !this.isActive(option);
  };

  RadioButtonGroup.prototype.isReadOnly = function isReadOnly() {
    if (this.props.readOnly) {
      return true;
    }
    return false;
  };

  RadioButtonGroup.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'Field Input RadioButtonGroup', style: { width: this.props.width }, 'data-read-only': this.isReadOnly() },
      React.createElement(Label, { text: this.props.label }),
      React.createElement(
        'div',
        { className: 'RadioButtonGroup-buttons' },
        this.props.options.map(function (opt, i) {
          var option = _this2.parseOption(opt);
          return React.createElement(
            'label',
            { className: 'Input-control RadioButtonGroup-button', 'data-active': _this2.isActive(option), key: i },
            React.createElement('input', { className: 'RadioButtonGroup-control', type: 'radio', onChange: _this2.handleChange, name: _this2.getRadioName(), value: option.value, checked: _this2.isActive(option), disabled: _this2.isDisabled(option) }),
            option.displayValue
          );
        })
      )
    );
  };

  return RadioButtonGroup;
}(Component);

export default RadioButtonGroup;